import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [ createPersistedState({ storage: window.sessionStorage }) ],
  state: {
    raDetail                : {},
    dataProducts         : {},
    accessToken             : null,
    memoryTabs              : null,
    isCopyDoc               : false,
    transactionId           : null,
    sessionExpired          : false,
    permissionInbox         : [],
    permissionEval          : [],
    confirmSelectedBiz      : {},
    selectedPermissionInbox : null,
    groupAccountIdCreatePurchase :false,
    permissionGlAccount    : false,
    PermissionSummary      : null,
    budgetType              : [],
    pettyCashPermission     : false,
    pettyCashPermissionTab  :[],
    evalDetail              :[],
    evaluatedData           :[],
    permissionBtnEditMode   : false
  },
  mutations: {
    setDataProducts(state, dataProducts) {
      state.dataProducts = dataProducts
    },
    setPettyCashPermission(state, permission) {
      state.pettyCashPermission = permission
    },
    setPettyCashPermissionTab(state, permissionPetty) {
      state.pettyCashPermissionTab = permissionPetty
    },
    setAccessToken(state, accessToken) {
      state.accessToken = accessToken
    },
    setRaDetail(state, raDetail) {
      state.raDetail = raDetail
    },
    setMemoryTabs(state, memoryTabs) {
      state.memoryTabs = memoryTabs
    },
    setConfirmSelectedBiz(state, confirmSelectedBiz) {
      state.confirmSelectedBiz = confirmSelectedBiz
    },
    setTransactionId(state, transactionId) {
      state.transactionId = transactionId
    },
    setIsCopyDoc(state, isCopyDoc) {
      state.isCopyDoc = isCopyDoc
    },
    setSessionExpired(state, status) {
      state.sessionExpired = status
    },
    setSelectedPermissionInbox(state, status) {
      state.selectedPermissionInbox = status
    },
    setPermissionInbox(state, status) {
      state.permissionInbox = status
    },
    setPermissionEval(state, permissionEval) {
      state.permissionEval = permissionEval
    },
    setPermissionGlAccount(state, permissionGlAccount) {
      state.permissionGlAccount = permissionGlAccount
    },
    setGetBudgetType(state, budgetType) {
      state.budgetType = budgetType
    },
    setEvalDetail(state, evalDetail) {
      state.evalDetail = evalDetail
    },
    setEvaluatedData(state, evaluatedData) {
      state.evaluatedData = evaluatedData
    },
    setPermissionBtnEditMode(state, value) {
    state.permissionBtnEditMode = value;
  },
  setGroupAccountIdCreatePurchase(state, value) {
    state.groupAccountIdCreatePurchase = value;
  },
  setPermissionSummary(state, value) {
    state.PermissionSummary = value;
  },

    clearAll(state) {
      state.dataProducts            = {},
      state.raDetail                = {},
      state.accessToken             = null,
      state.isCopyDoc               = false,
      state.transactionId           = null,
      state.sessionExpired          = false,
      state.permissionInbox         = [],
      state.memoryTabs              = null,
      state.groupAccountIdCreatePurchase  = false,
      state.permissionEval          = [],
      state.permissionGlAccount    = false,
      state.confirmSelectedBiz      = {}
      state.selectedPermissionInbox = null
      state.budgetType              = []
      state.pettyCashPermissionTab  = []
      state.evalDetail  = []
      state.evaluatedData  = []
       state.permissionBtnEditMode = false;
        state.PermissionSummary = false;
    }
  },
  getters: {
    dataProducts            : state => state.dataProducts,
    raDetail                : state => state.raDetail,
    isCopyDoc               : state => state.isCopyDoc,
    accessToken             : state => state.accessToken,
    transactionId           : state => state.transactionId,
    sessionExpired          : state => state.sessionExpired,
    memoryTabs              : state => state.memoryTabs,
    permissionInbox         : state => state.permissionInbox,
    permissionEval          : state => state.permissionEval,
    permissionGlAccount    : state => state.permissionGlAccount,
    confirmSelectedBiz      : state => state.confirmSelectedBiz,
    selectedPermissionInbox : state => state.selectedPermissionInbox,
    budgetType              : state => state.budgetType,
    pettyCashPermission     : state => state.pettyCashPermission,
    pettyCashPermissionTab  : state => state.pettyCashPermissionTab,
    evalDetail              : state => state.evalDetail,
    evaluatedData              : state => state.evaluatedData,
    permissionBtnEditMode   : state => state.permissionBtnEditMode,
    groupAccountIdCreatePurchase  : state => state.groupAccountIdCreatePurchase,
    PermissionSummary      : state => state.PermissionSummary
  },
  actions: {
    clearAll: ({ commit }) => {
      commit('clearAll')
    }
  }
});
